import { computed, signal } from "@preact/signals-react"
import { countries } from "./region"

const form_field = signal([
	{
		name: "nickname",
		type: "text",
		sort: 1,
		required: true,
		readOnly: true,
	},
	{
		name: "uid",
		type: "text",
		sort: 2,
		required: true,
		readOnly: true,
	},
	{
		name: "name",
		type: "text",
		sort: 3,
		required: true,
		maxLength: 35,
		readOnly: false,
	},
	{
		name: "country",
		type: "select",
		sort: 5,
		required: true,
		readOnly: false,
	},
	{
		name: "province",
		type: "select",
		sort: 6,
		required: true,
		readOnly: false,
	},
	{
		name: "city",
		type: "select",
		sort: 7,
		required: true,
		readOnly: false,
	},
	{
		name: "district",
		type: "select",
		sort: 8,
		required: true,
		readOnly: false,
	},
	{
		name: "postal_code",
		type: "text",
		sort: 9,
		required: true,
		maxLength: 5,
		readOnly: false,
	},
	{
		name: "address",
		type: "textarea",
		sort: 10,
		required: true,
		maxLength: 200,
		readOnly: false,
	},
	{
		name: "country_dial_code",
		type: "select",
		sort: 11,
		required: true,
		readOnly: true,
	},
	{
		name: "phone_number",
		type: "tel",
		sort: 12,
		required: true,
		maxLength: 13,
		readOnly: false,
	},
	{
		name: "email",
		type: "email",
		sort: 13,
		required: true,
		readOnly: false,
	},
	{
		name: "address_name",
		type: "text",
		sort: 14,
		required: true,
		readOnly: false,
	}
])

const sort_field = computed(() => form_field.value.sort((a, b) => a.sort - b.sort))

const form_data = signal({
	agree: "",
})

const selected_data = signal({
	country: '',
	province: '',
	city: '',
	district: '',
	country_dial_code: ''
})

const changeFormData = (key, value) => {
	form_data.value = {
		...form_data.value,
		[key]: value,
	}
}

const changeSelected = (key,value) =>{
	selected_data.value = {
		...selected_data.value,
		[key]: value,
	}
}

const set_dial_code_selected = (country_code) => {
	let country = countries.value[country_code];
	if (country) {		
		changeFormData(`country_dial_code`, country_code)
	}
}
const createNewObject = () => {
	const newObj = {}

	form_field.value.forEach((item) => {
		newObj[item.name] = ""
	})

	return newObj
}

const adjustInitialFormData = () => {
	let newData = createNewObject()
	form_data.value = {
		...form_data.value,
		...newData,
	}
}

export { form_data, selected_data, form_field, sort_field, set_dial_code_selected, adjustInitialFormData, changeFormData, changeSelected }
